export const ORG = {
  name: "ONE LIFE EDUCATION",
  registeredName: "ONE LIFE EDUCATION",
  mobile: "7032167659",
  email: "onelifeeducationsociety@gmail.com",
  address : "3-78, Kodad Main Road, Nayanagar, Kodad, Suryapet, Telangana, 508206",
  website : "https://onelifeeducation.in/",
  web : "onelifeeducation.in",
  hours:"9AM to 6PM"
};

export const formatINR = (amount) => `INR ${amount}`;

export const API_URL = 'https://onelifeeducation.in/rest/';
export const IMAGE_PATH = 'https://onelifeeducation.in/rest/uploads/';

export const MAX_RESULTS = 10;

export const LOGOUT_TIME = 1000 * 60 * 24; //replace last value with how many minutes

